import React from 'react';
import PropTypes from 'prop-types';
import { times } from 'lodash';
import { TableCell, TableRow } from '@material-ui/core';
import styled from 'styled-components';
import { lighten, em } from 'polished';
import format from 'date-fns/format';
import { mediaQuery } from '../../common';
import { COLUMNS } from '../constants';
import { appTheme } from '../../../theme';

const getColumnHeadings = (value, index) =>
  `&:nth-child(${index + 1})::before {
    content: '${!!value ? `${value}: ` : ''}';
    font-weight: bold;
    margin-right: ${!!value ? em(10) : 0};
  }`;

const Cell = styled(TableCell)`
  ${COLUMNS.map(getColumnHeadings)};

  ${mediaQuery.xlarge`
    display: table-cell;
    padding: 4px 56px 4px 24px; /* pixel values to match material-ui */

    ${times(COLUMNS.length, index => getColumnHeadings('', index))}
  `};

  /* stylelint-disable-next-line order/properties-alphabetical-order */
  display: block;
  padding: ${em(appTheme.spacing.medium)};
`;

const Row = styled(TableRow)`
  &:nth-child(even) {
    background-color: ${lighten(0.07, appTheme.system.border)};
  }
`;

const getDisplayIdleTime = idleTime =>
  idleTime === 60 ? '1 hour' : `${idleTime} min`;

function SavedNotification({
  frequency,
  frequencyUnit,
  idleTime,
  locationName,
  isActive,
  text,
  timeOfDay,
}) {
  return (
    <Row>
      <Cell>{text}</Cell>
      <Cell>{locationName}</Cell>
      <Cell>
        {frequency} per {frequencyUnit}
      </Cell>
      <Cell>{getDisplayIdleTime(idleTime)}</Cell>
      <Cell>{!!timeOfDay ? format(timeOfDay, 'h:mm a') : 'None Selected'}</Cell>
      <Cell>{isActive ? 'Active' : 'Inactive'}</Cell>
    </Row>
  );
}

SavedNotification.propTypes = {
  frequency: PropTypes.number.isRequired,
  frequencyUnit: PropTypes.string.isRequired,
  idleTime: PropTypes.number.isRequired,
  isActive: PropTypes.bool.isRequired,
  locationName: PropTypes.string.isRequired,
  text: PropTypes.string.isRequired,
  timeOfDay: PropTypes.string,
};

export default SavedNotification;



// WEBPACK FOOTER //
// ./src/modules/NotificationManagement/components/SavedNotification.js